/*判断当前环境*/
export const DeviceType = () => {
  var u = navigator.userAgent;
  if (u.match(/Android/i) != null) {
    return "Android";
  } else if (u.match(/iPhone|iPod|ios/i) != null) {
    return "IOS";
  }
};
/*监听与原生通信事件*/
function connectWebViewJavascriptBridge(callback) {
  if (DeviceType() === "Android") {
    if (window.WebViewJavascriptBridge) {
      callback(WebViewJavascriptBridge);
    } else {
      document.addEventListener(
        "WebViewJavascriptBridgeReady",
        function() {
          callback(WebViewJavascriptBridge);
        },
        false
      );
    }
  } else if (DeviceType() === "IOS") {
    if (window.WebViewJavascriptBridge) {
      return callback(WebViewJavascriptBridge);
    }
    if (window.WVJBCallbacks) {
      return window.WVJBCallbacks.push(callback);
    }
    document.addEventListener(
      "WebViewJavascriptBridgeReady",
      function() {
        callback(WebViewJavascriptBridge);
      },
      false
    );
    window.WVJBCallbacks = [callback];
    var WVJBIframe = document.createElement("iframe");
    WVJBIframe.style.display = "none";
    WVJBIframe.src = "https://__bridge_loaded__";
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(function() {
      document.documentElement.removeChild(WVJBIframe);
    }, 0);
  }
}

/* 创建与原生回调方法 */
let init = function() {
  connectWebViewJavascriptBridge(function(bridge) {
    if (DeviceType() === "Android") {
      /* 安卓需要初始化 */
      bridge.init(function(message, responseCallback) {
        console.log("JS got a message", message);
        var data = {
          "Javascript Responds": "测试中文!",
        };
        if (responseCallback) {
          console.log("JS responding with", data);
          responseCallback(data);
        }
      });
    }
  });
};

// todo isNotWeiXin判断是否是微信环境
let isNotWeiXin =
  navigator.userAgent.toLowerCase().match(/MicroMessenger/i) ==
  "micromessenger";
if (!isNotWeiXin) {
  init();
}

/*调用原生 有回调*/
export default {
  /* JS调用原生有回调 */
  callHandler(name, data, callback) {
    connectWebViewJavascriptBridge(function(bridge) {
      bridge.callHandler(name, data, callback);
    });
  },
  /* 原生调用JS */
  registerhandler(name, callback) {
    connectWebViewJavascriptBridge(function(bridge) {
      bridge.registerHandler(name, function(data, responseCallback) {
        callback(data, responseCallback);
      });
    });
  },
  /*调用原生方法 没有回调*/
  commonCall(fn, arg) {
    if (DeviceType() === "Android") {
      try {
        if (arg) {
          window.JsBridge[fn](arg);
        } else {
          window.JsBridge[fn]();
        }
      } catch (e) {
        console.log("进入catch抛出错误", e);
      }
    } else if (DeviceType() === "IOS") {
      try {
        window.webkit.messageHandlers[fn].postMessage(arg);
      } catch (e) {
        console.log("进入catch抛出错误", e);
      }
    }
  },
};
